import React, { useMemo } from 'react';
import classNames from 'classnames';

import { useUserInfo } from 'lib/user';
import { useAppSelector } from 'store/hooks';
import { useRouter } from 'next/router';
import { Mail01 } from 'lib/lucky-x-icons-2';

const NotifyBtn = () => {
  const router = useRouter();
  const { subscriptions } = useUserInfo();
  const { isSubcribeSuccess } = useAppSelector((state) => state.user);

  const hasSubscriptions = useMemo(() => {
    return !!subscriptions && subscriptions?.length !== 0;
  }, [subscriptions]);

  if (hasSubscriptions || isSubcribeSuccess) {
    return null;
  }

  return (
    <div
      className={classNames(
        'mt-6 flex h-10 w-full items-center justify-center gap-2 rounded-full ',
        {
          'active:buttonShadow cursor-pointer bg-primary-500 text-neutral-100 hover:bg-primary-600':
            !hasSubscriptions && !isSubcribeSuccess,
          'cursor-not-allowed bg-neutral-900 text-neutral-600':
            hasSubscriptions || isSubcribeSuccess,
        }
      )}
      onClick={() => {
        router.push('/profile');
      }}
    >
      <Mail01 size={20} />
      <div className="text-base font-normal ">Notify me when I win</div>
    </div>
  );
};

export default NotifyBtn;
